import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRotate90Left24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconRotate90Left24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18 13v3.5h1a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 19 3.5h-6A1.5 1.5 0 0 0 11.5 5v5H15a3 3 0 0 1 3 3m1 5h-1v1a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h5V5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3M3.5 19v-6A1.5 1.5 0 0 1 5 11.5h10a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 19M5.75 2H8.5v1.5H5.75A2.25 2.25 0 0 0 3.5 5.75V8.5H2V5.75A3.75 3.75 0 0 1 5.75 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRotate90Left24);
